import { EProfileType } from '../entities/IGlobal';

export type TPrincipalType = number | string | null | undefined;
type TGroupId = string | null | undefined;
type TGroupMembershipProfile = {
    [key: string]: unknown;
    groups?: unknown;
    organizationsGroups?: unknown;
} | null | undefined;

const GROUP_PRINCIPAL_TYPES = new Set<TPrincipalType>([
    1,
    '1',
    'Group',
    'group',
    EProfileType.Group
]);

export const isGroupPrincipal = (type: TPrincipalType): boolean => GROUP_PRINCIPAL_TYPES.has(type);

export const normalizePrincipalType = (type: TPrincipalType): EProfileType =>
    (isGroupPrincipal(type) ? EProfileType.Group : EProfileType.Personal);

export type TDateActor = {
    id?: string;
    childId?: string;
    picture?: string;
    firstName?: string;
    lastName?: string;
    name?: string;
    childName?: string;
    type?: TPrincipalType;
};

/** Falls back to `childName`/`name` (wire DTOs using childId/childName instead of firstName/lastName). */
export const getActorDisplayName = (actor: TDateActor): string =>
    `${actor.firstName || ''} ${actor.lastName || ''}`.trim() || (actor.childName || actor.name || '').trim();

/** Falls back to `childId` (wire DTOs where `id` is the principal-record id, may be empty). */
export const getActorId = (actor: TDateActor): string =>
    actor.childId || actor.id;

/** Maps date actors to ColoredDatagrid People cells (`firstName`/`lastName`/`id`). */
export const mapDateActorToPeopleMember = (actor: TDateActor) => ({
    id: getActorId(actor),
    picture: actor.picture,
    firstName: getActorDisplayName(actor),
    lastName: '',
    type: normalizePrincipalType(actor.type)
});

export const isCurrentUserInGroup = (groupId: TGroupId, currentUserProfile: TGroupMembershipProfile): boolean => {
    if (!groupId || !currentUserProfile) {
        return false;
    }
    const userGroups = Array.isArray(currentUserProfile.groups) ? currentUserProfile.groups : [];
    const organizationGroups = Array.isArray(currentUserProfile.organizationsGroups) ? currentUserProfile.organizationsGroups : [];
    return userGroups.includes(groupId) || organizationGroups.includes(groupId);
};
